import React, { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../../api/axiosInstance";
import moment from "moment";
import "./tankstellen.scss"

const Tankstellen = () => {
    const [items, setItems] = useState([]);

    const fetchData = useCallback(async () => {
        try {
            const res = await axiosInstance.get("/tankstelle/tankstellen");
            setItems(res.data);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <div className="tankstellen">
            <div className="tableWrapper">
                <table>
                    <thead>
                        <tr>
                            <th>ID/Bezeichnung</th>
                            <th>Infrastruktur Typ</th>
                            <th>Status</th>
                            <th>Auslastung/Füllstand</th>
                            <th>Letzte Nutzung</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((i) => (
                            <tr key={i.id}>
                                <td>
                                    <bold>{i.identity} - {i.connectorId}</bold>
                                </td>
                                <td>{i.type}</td>
                                <td className="tankstellenStatus">
                                    <div className={`grid ${i.status}`}>
                                        <div className="dot" />
                                        <bold>{i.status}</bold>
                                    </div>
                                </td>
                                <td></td>
                                <td>{i.updatedAt && moment(i.updatedAt).fromNow()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
};

export default Tankstellen